module.exports = __webpack_public_path__ + "static/media/SackersGothicStd-Medium.5812e9d6.otf";